<template>
  <div id="app" class="bench_content" ref="app">
    <!-- 修改密码 -->
    <!-- header -->
    <header-a
      @roleType="clickRole"
      @orderDetail="handleOrder"
      :configStatus="configFinished"
      @renew="handleRenew"
      @backBench="handleEditBackBench"
      :isEditInfo="isEditInfo"
    ></header-a>
    <div class="center" v-if="!isEditInfo">
      <div class="center_nr" v-if="showOrderOrCard == 'home'">
        <div class="banner">
          <img
            :src="schoolUrl + schoolData.topBanner"
            v-if="schoolData.topBanner"
          />
          <img :src="schoolUrl + 'default/sc_banner.png'" v-else />
        </div>
        <div class="school_manage">
          <img src="../../assets/img/bench/school1@2x.png" />
          <h2>校园管理</h2>
        </div>
        <el-row>
          <el-col :span="4" v-for="(item, index) in myappList" :key="index">
            <div
              class="cardItem"
              @click="clickGo(item.appId, item.appName, item.appUrl)"
            >
              <!-- <div class="cardItem_img"> -->
              <img :src="item.appIcon" alt="" srcset="" />
              <!-- </div> -->
              <div class="cardItem_text">
                {{ item.appName }}
              </div>
            </div>
          </el-col>
          <el-col :span="4" v-if="seedInfo.isShow == 1">
            <div class="cardItem" @click="jumpSeed(seedInfo.jumpUrl)">
              <!-- <div class="cardItem_img"> -->
              <img src="../../assets/img//bench/seed.png" alt="" srcset="" />
              <!-- </div> -->
              <div class="cardItem_text">西工智育成长</div>
            </div>
          </el-col>
        </el-row>
        <div class="quality_evaluation" v-if="roleType == 'school'">
          <img src="../../assets/img/bench/zp@2x.png" />
          <h2>综合素质评价</h2>
        </div>
        <div class="step_content" v-if="roleType == 'school'">
          <el-steps :active="stepIndex" align-center>
            <el-step
              :title="item.progressItemName"
              v-for="(item, index) in progressStatusList"
              :key="index"
            >
              <i
                :class="item.progressItemStatus == 1 ? 'step01' : 'step02'"
                slot="icon"
              ></i>
            </el-step>
            <!-- <el-step title="课程开设" >
              <i :class=" courseOfferingStatus ? 'step01':'step02'" slot="icon"></i>
            </el-step>
            <el-step title="课程观测点" >
              <i :class="keyPointsStatus ? 'step01':'step02'" slot="icon"></i>
            </el-step>
            <el-step title="课程卡定制" >
              <i :class="courseCard ? 'step01':'step02'" slot="icon"></i>
            </el-step> -->
          </el-steps>
          <div class="step_card">
            <div v-if="stepIndex == targetStatus">
              <h2>评价指标体系是指学校对学生各方面及其相互联系的多个指标</h2>
              <!-- 第一步 -->
              <div class="step_desc">
                <div class="desc_l">
                  <div
                    :class="{
                      pdfz: index == 0,
                      xysp: index == 1,
                      yssy: index == 2,
                      sxjk: index == 3,
                      shsj: index == 4,
                    }"
                    class="step_desc_item df ai-c"
                    v-for="(item, index) in evaluateList"
                    :key="index"
                  >
                    <div class="item_tit df df-c ai-c jc-c">
                      <img
                        v-show="index == 0"
                        src="../../assets/img//bench/pdfz.png"
                        alt=""
                      />
                      <img
                        v-show="index == 1"
                        src="../../assets/img//bench/xybx.png"
                        alt=""
                      />
                      <img
                        v-show="index == 2"
                        src="../../assets/img//bench/smsy.png"
                        alt=""
                      />
                      <img
                        v-show="index == 3"
                        src="../../assets/img//bench/sxjk.png"
                        alt=""
                      />
                      <img
                        v-show="index == 4"
                        src="../../assets/img//bench/shsj.png"
                        alt=""
                      />
                      <div>#{{ item.nodeName }}#</div>
                    </div>
                    <div class="item_detail df">
                      <div v-for="(ite, i) in item.childs" :key="i">
                        <span class="text_bold">{{ ite.nodeName }}</span>
                        <template v-if="ite.childs.length > 0">
                          (
                          <span v-for="(it, ind) in ite.childs" :key="ind"
                            >{{ it.nodeName }}、</span
                          >
                          )
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="desc_r df df-c jc-sb ai-c">
                  <img
                    src="../../assets/img//bench/tree1.png"
                    alt=""
                    style="width: 245px; height: 328px"
                  />
                  <div class="btns df jc-e" style="width: 100%">
                    <el-button
                      size="mini"
                      plain
                      type="primary"
                      @click="handleNext(1, 'saveTemplate')"
                      >下一步:{{
                        progressStatusList[1] &&
                        progressStatusList[1].progressItemName
                      }}</el-button
                    >
                  </div>
                </div>
              </div>
            </div>

            <!-- 第二部 课程开设 -->
            <div v-if="stepIndex == courseOfferingStatus">
              <zpCourse @prevOrNext="handleNext" />
            </div>
            <!-- 第三步 课程观测点 -->
            <div v-if="stepIndex == keyPointsStatus">
              <observation @prevOrNext="handleNext" />
            </div>
            <!-- 第四步 课程卡印制 -->
            <div v-if="stepIndex == courseCard && !configFinished">
              <customization @prevOrNext="handleNext" />
            </div>
            <!-- 配置完成展示页 -->
            <!-- <div v-if="courseCard" class="end_config df"> -->
            <div v-if="configFinished" class="end_config df">
              <div class="check_info df df-c jc ai-c">
                <div class="check_info_text">
                  校本化配置已完成，课程卡制作请前往订单管理查看
                </div>
                <el-button size="small" type="primary" @click="handleOrder"
                  >立即查看</el-button
                >
              </div>
              <img
                class="check_img"
                src="../../assets/img/bench/finishimg@2x.png"
                alt=""
              />
            </div>
            <div class="end_config df" v-if="noTemplate">
              <!-- <div class="check_info df df-c jc ai-c">
                <div class="check_info_text">
                  学校未配置综评模板，请联系平台客服申请
                </div>
                <el-button size="small" type="primary" @click="handleHelp"
                  >立即反馈</el-button
                >
              </div> -->
              <img
                class="check_img"
                src="../../assets/img/bench/finishimg@2x.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="center_nr"
        v-if="roleType == 'school' && showOrderOrCard == 'order'"
      >
        <order @backBench="handleBackBench"></order>
      </div>
      <div
        class="center_nr"
        v-if="roleType == 'school' && showOrderOrCard == 'card'"
      >
        <cardCustomization @backBench="handleBackBench"></cardCustomization>
      </div>
      <div
        class="center_nr"
        v-if="roleType == 'school' && showOrderOrCard == 'orderDetail'"
      >
        <orderDetail @backBench="handleBackBench"></orderDetail>
      </div>
      <!-- <router-view></router-view> -->
      <!-- 右侧边栏 -->
      <div class="sidebar">
        <div class="user_info">
          <div class="user_avatar">
            <!-- <img
                style="height: 60px"
                src="../../assets/img/sex0.png"
            /> -->
            <el-image
              class="imglogo"
              :src="hostUrl + userDatas.headPhotoUrl"
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <i
                  ><img
                    style="height: 60px"
                    v-if="userDatas.sex == 1"
                    src="../../assets/img/sex0.png"
                    alt=""
                    srcset=""
                /></i>
                <i
                  ><img
                    style="height: 60px"
                    v-if="userDatas.sex == 0"
                    src="../../assets/img/默认头像.png"
                    alt=""
                    srcset=""
                /></i>
                <i
                  ><img
                    style="height: 60px"
                    v-if="userDatas.sex == null"
                    src="../../assets/img/默认头像.png"
                    alt=""
                    srcset=""
                /></i></div
            ></el-image>
            <img
              @click="handelEditInfo"
              :class="[commonIcon, editIcon]"
              src="../../assets/img/bench/edit@2x.png"
              alt=""
            />
          </div>
        </div>
        <div class="user_detail">
          <div class="detail_item">
            <div class="item_tit school_tcolor">
              <img src="../../assets/img/bench/school1@2x.png" alt="" />
              学校
            </div>
            <div class="item_content">
              {{ schoolData.name }}
            </div>
          </div>
          <div class="detail_item">
            <div class="item_tit motto_tcolor">
              <img src="../../assets/img/bench/xx@2x.png" alt="" />
              校训
            </div>
            <div class="item_content">
              {{ schoolData.schoolMotto }}
              <!-- <div>让每个人都能够成为,更加优秀的自己好好学习天天向上好身体</div> -->
            </div>
          </div>
          <div class="detail_item">
            <div class="item_tit schoolspirit_tcolor">
              <img src="../../assets/img/bench/xf@2x.png" alt="" />
              校风
            </div>
            <div class="item_content">
              {{ schoolData.schoolSpirit }}
            </div>
          </div>
          <div class="detail_item">
            <div class="item_tit school_badge">
              <img src="../../assets/img/bench/xh@2x.png" alt="" />
              校徽
            </div>
            <div class="item_content">
              <img
                v-if="schoolData.schoolLogo"
                :src="schoolUrl + schoolData.schoolLogo"
                style="height: 50px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="footer">
      <foo-ter></foo-ter>
    </div> -->
    <teacherBasic v-else></teacherBasic>
  </div>
</template>
<script>
import fooTer from '../footer/footer'
import addBookss from './components/addbook'
import headerA from '../header/header'
import zpCourse from './components/zpcourse.vue'
import observation from './components/observation.vue'
import customization from './components/customization.vue'
import order from './components/order.vue'
import cardCustomization from './components/cardCustomization.vue'
import orderDetail from './components/orderDetail.vue'
import teacherBasic from './teacherBasic.vue'
import {
  usercenterinfo,
  schoolgetinfo,
  getBookList,
  deleteBook,
  getBookSubjectList,
  getVersionList,
  getVolumeList,
  getChaptertreeVo,
  addBook,
  getMyappList,
  UserLogout,
  modifyPassWord,
  getSchoolTemplate,
  getSchoolConfigStep,
  saveTargetTemplate,
  secretFreeLogin,
} from '@/api/home'
import resetMessage from '@/assets/js/resetMessage'
export default {
  components: {
    addBookss,
    headerA,
    fooTer,
    zpCourse,
    observation,
    customization,
    order,
    cardCustomization,
    orderDetail,
    teacherBasic,
  },
  data() {
    return {
      userData: [],
      userDatas: [],
      schoolData: [],
      visible: false,
      token: '',
      schoolId: 0,
      roleType: localStorage.getItem('roleType'),
      hostUrl: '', //根路径
      passform: {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',
      },
      height: 0,
      myappList: [],
      roleId: '',
      stepIndex: 0, //步骤条index
      evaluateList: [], //综评数据
      targetStatus: undefined, //指标状态 index
      courseOfferingStatus: undefined, //课程开设状态 index
      keyPointsStatus: undefined, //观测点状态 index
      courseCard: undefined, //课程卡状态 index
      configFinished: false, //配置是否完成
      showOrderOrCard: 'home', //是否显示订单页
      commonIcon: '',
      editIcon: 'edit_icon',
      noTemplate: false, //是否开通综评模板，
      progressStatusList: [],
      isEditInfo: false,
      schoolUrl: '',
      seedInfo: {},
    }
  },
  async created() {
    this.token = this.$route.query.token
    if (this.token) {
      localStorage.setItem('token', this.token)
      this.usercenterinfo()
    } else {
      this.token = localStorage.getItem('token')
      this.usercenterinfo()
    }
    this.getConfigProgress()
    this.getMyappList()
  },
  methods: {
    //获取配置进度
    async getConfigProgress() {
      //获取学校配置进度
      let { data: res } = await getSchoolConfigStep()
      let progressArr = res.data.cardPrintItemList
      this.progressStatusList = progressArr
      console.log('配置list:', progressArr)
      if (progressArr.length == 0) {
        this.noTemplate = true
      }
      console.log('this.noTemplate:', this.noTemplate)
      progressArr.forEach((item, index) => {
        switch (item.progressItemCode) {
          case 'index_sys':
            this.targetStatus = index
            break
          case 'create_school_course':
            this.courseOfferingStatus = index
            break
          case 'course_view_point':
            this.keyPointsStatus = index
            break
          case 'course_customize':
            this.courseCard = index
            break
          default:
            break
        }
      })
      console.log(
        this.targetStatus,
        this.courseOfferingStatus,
        this.keyPointsStatus,
        this.courseCard
      )
      if (res.data.isConfig) {
        this.stepIndex = 4
        this.configFinished = true
      } else {
        let obj = progressArr.find((item) => item.progressItemStatus == 0)
        let index = progressArr.indexOf(obj)
        if (index >= 3) {
          index = 3
        }
        this.stepIndex = index
        console.log('配置进度', index)
      }
    },
    //   获取当前用户登陆信息
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      console.log('当前登录账号信息', res.data)
      localStorage.setItem('userId', res.data.userId)
      this.userData = res.data
      this.schoolId = res.data.schoolId
      localStorage.setItem('schoolIds', res.data.schoolId)
      localStorage.setItem('roleTypes', res.data.roleType)
      localStorage.setItem('roleType', res.data.roleType)
      this.roleType = res.data.roleType
      this.hostUrl = res.data.hostUrl
      this.schoolgetinfo()
      if (res.data.roleType == 'teacher') {
        this.userDatas = res.data.teacher
      } else if (res.data.roleType == 'school') {
        this.userDatas = res.data.school
        this.commonIcon = 'common_icon'
      } else {
        this.userDatas = res.data.student
      }
    },
    // 获取当前登陆用户的学校信息
    async schoolgetinfo() {
      const { data: res } = await schoolgetinfo({
        id: this.schoolId,
      })

      this.schoolData = res.data
      this.schoolUrl =
        res.data.bucketId == 2
          ? 'https://file.51xiaoping.com/'
          : 'https://cdn.51xiaoping.com/'
    },
    xgpassword() {
      this.visible = true
    },

    // 获取我的应用列表
    async getMyappList() {
      if (!this.roleId) {
        this.roleId = -1003
      }
      const { data: res } = await getMyappList({
        roleId: this.roleId,
      })
      console.log('应用列表', res.data)
      this.myappList = res.data
    },
    clickRole(e) {
      this.roleId = e
      this.getMyappList()
    },
    //跳转订单详情
    handleOrder(val) {
      console.log(val)
      // this.$router.push('bench/orderList')
      this.showOrderOrCard = 'order'
    },
    //跳转客服
    handleHelp() {
      // window.open(appUrl + '?token=' + this.token +'&roleId=' + this.roleId)
      window.open('https://help.51xiaoping.com/#/')
    },
    //切换身份，更新roletype
    handleRenew() {
      this.roleType = localStorage.getItem('roleType')
      this.showOrderOrCard = 'home'
    },
    //配置完成
    handleConfig() {},
    //修改资料返回工作台
    handleEditBackBench() {
      console.log('返回工作台:')
      this.isEditInfo = false
    },
    //返回工作台
    handleBackBench(val) {
      console.log(val)
      this.showOrderOrCard = val
    },
    jumpSeed(url) {
      window.open(url)
    },
    clickGo(appId, appName, appUrl) {
      // if (appId == '13') {
      //   if (appName == '班级管理') {
      //     // localStorage.setItem('appName',appName)
      //     this.$router.push('/school/classes')
      //   } else {
      //     this.$router.push(appUrl)
      //   }
      // } else {
      //   // window.open(appUrl + '?token=' + this.token +'&roleId=' + this.roleId)
      // }
      window.open(appUrl + '?token=' + this.token + '&roleId=' + this.roleId)
    },
    //立即查看跳转
    handleCheck() {
      let obj = this.myappList.find((item) => item.appId == 14)
      window.open(
        obj.appUrl + '?token=' + this.token + '&roleId=' + this.roleId
      )
    },
    //步骤条下一步
    handleNext(index, str) {
      if (index === 'true') {
        console.log(index)
        this.stepIndex = 4
        this.configFinished = true
      } else {
        if (str == 'saveTemplate') {
          saveTargetTemplate().then((res) => {
            if (res.data.code == '0') {
              this.stepIndex = index
            } else {
              resetMessage({
                type: 'error',
                message: res.msg,
              })
            }
          }) //保存模板
        } else {
          this.stepIndex = index
        }
      }
    },
    //获取学校模板
    async getTemplate() {
      let { data: res } = await getSchoolTemplate()
      this.evaluateList = res.data.nodeList
    },
    //编辑个人信息
    handelEditInfo() {
      if (this.userData.roleType == 'school') {
        return
      } else {
        // this.$router.push('/teacherbasic')
        this.isEditInfo = true
      }
    },
    secretFreeLogin() {
      if (!localStorage.getItem('userId')) return
      let params = {
        userId: localStorage.getItem('userId'),
      }
      if (this.roleId == -1004) {
        params.roleType = 'school'
      } else if (this.roleId == -1003) {
        params.roleType = 'teacher'
      }
      secretFreeLogin(params).then((res) => {
        this.seedInfo = res.data.data
      })
    },
  },
  watch: {
    roleId(v) {
      this.secretFreeLogin()
    },
    async stepIndex() {
      let { data: res } = await getSchoolConfigStep()
      if (res.data.isConfig) {
        this.configFinished = true
      }
      this.progressStatusList = res.data.cardPrintItemList
      // let progressArr = res.data.cardPrintItemList
      //   progressArr.forEach(item => {
      //     switch (item.progressItemCode) {
      //       case 'index_sys':
      //         this.targetStatus = item.progressItemStatus==0?false:true
      //         break;
      //       case 'create_school_course':
      //         this.courseOfferingStatus = item.progressItemStatus==0?false:true
      //         break;
      //       case 'course_view_point':
      //         this.keyPointsStatus = item.progressItemStatus==0?false:true
      //         break;
      //       case 'course_customize':
      //         this.courseCard = item.progressItemStatus==0?false:true
      //         break;
      //       default:
      //         break;
      //     }
      //   });
    },
  },
  mounted() {
    // this.height = this.$refs.app.offsetHeight
    // this.height =window.getComputedStyle(this.$refs.app).height;
    // console.log(this.height);
    this.getTemplate()
  },
}
</script>
<style lang="less" scoped>
// #app {
// background-color: #f5f8fd;
// width: 100%;
// height: 100%;

// }
.bench_content {
  background-color: #f5f8fd;
  width: 100%;
  min-height: 100vh;
}
.header {
  background-color: #fff;
  height: 60px;
  box-shadow: 0 2px 4px 0 rgba(1, 0, 0, 0.1);
}
.header img {
  margin-top: 5px;
  margin-left: 30px;
  height: 50px;
}

.hearder_right {
  float: right;
  height: 40px;
  margin-top: 10px;
  margin-right: 30px;
  cursor: pointer;
}
.header_btn {
  float: left;
  margin-top: 4px;
}
.hearder_right_user {
  float: right;
  margin-left: 30px;
}

.imglogo {
  width: 60px;
  height: 60px;
  text-align: center;
  border-radius: 50%;
}
.username {
  float: right;
  font-size: 16px;
  margin-top: 10px;
  margin-left: 15px;
}
.booklist {
  margin-bottom: 8px;
}

.huang {
  color: #e2754a;
  cursor: pointer;
  float: right;
}
.el-col-24 {
  margin-bottom: 10px;
}
.el-col-8 {
  margin-bottom: 5px;
}
.active {
  color: #306ef3;
}

.header_right_se li {
  cursor: pointer;
  list-style: none;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
}
.header_right_se li:hover {
  background-color: #f4f4f4;
}
.center {
  height: calc(100%-60px);
  width: 75%;
  min-width: 1200px;
  margin: 0 auto;
  margin-top: 15px;
  // padding-top: 60px;
  background-color: #f5f8fd;
  display: flex;
  padding-bottom: 30px;
  // height: 100%;
}

.center_nr {
  margin: 0 auto;
  /* width: 1200px; */
  width: 80%;
  margin-right: 10px;
}
.sidebar {
  width: 20%;
  // min-width: 301px;
  // border-radius: 5px;
  // padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  // height: 80vh;
  min-height: calc(100vh - 105px);
  .user_info {
    background: url('~@/assets/img/bench/userbg.png') no-repeat 100% 100%;
    background-position: center;
    height: 176px;
    text-align: center;
    margin-bottom: 30px;
    .user_avatar {
      padding-top: 25px;
      position: relative;
      .edit_icon {
        cursor: pointer;
        position: absolute;
        left: 52%;
        top: 77%;
        width: 25px;
        height: 24px;
      }
      .common_icon {
        cursor: auto !important;
      }
    }
    .user_type {
      margin: 10px 0 15px;
    }
  }
  .user_detail {
    .detail_item {
      margin: 10px;
      display: flex;
      height: 69px;
      background: #f5f9fd;
      .item_tit {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 69px;
        width: 60px;
        // padding: 5px 0;
        img {
          margin-bottom: 5px;
          width: 30px;
          height: 30px;
        }
      }
      .school_tcolor {
        color: #498bff;
      }
      .motto_tcolor {
        color: #8486f8;
      }
      .schoolspirit_tcolor {
        color: #ff9a5a;
      }
      .school_badge {
        color: #5dbbff;
      }
      .item_content {
        display: flex;
        align-items: center;
        // display: table;
        width: 240px;
        // div{
        //   display: table-cell;
        //   vertical-align: middle;
        //   text-align: center;
        // }
        img {
          max-height: 69px;
          max-width: 190px;
        }
      }
    }
  }
}
.banner img {
  width: 100%;
  display: block;
  height: 240px;
  object-fit: cover; //图片不缩放，展示中间部分
}
.school_manage,
.quality_evaluation {
  margin: 10px 0 2px 0;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  background-color: #fff;
  h2 {
    margin-left: 10px;
  }
  img {
    width: 30px;
    height: 30px;
  }
}

.step_content {
  background-color: #fff;
  .step_card {
    padding: 10px 20px;
    h2 {
      margin-bottom: 20px;
    }
    .step_desc {
      display: flex;
      .desc_l {
        width: 60%;
        .step_desc_item {
          margin-bottom: 10px;
          padding: 10px;
          .item_tit {
            width: 150px;
          }
          .item_detail {
            flex-wrap: wrap;
            padding-left: 10px;
            color: #000;
            .text_bold {
              font-weight: bold;
              margin-right: 5px;
            }
          }
        }
        .pdfz {
          background-color: #fff5f5;
          color: #ff6d62;
        }
        .xysp {
          background-color: #f3f9ff;
          color: #72bfff;
        }
        .sxjk {
          background-color: #eefffb;

          color: #51d2b3;
        }
        .yssy {
          background-color: #f5f6ff;
          color: #8995ff;
        }
        .shsj {
          background-color: #fff8f5;
          color: #ff8f5c;
        }
      }
      .desc_r {
        width: 40%;
      }
    }
    .end_config {
      position: relative;
      // margin-top: 50px;
      height: 290px;
      .check_info {
        width: 100%;
        height: 210px;
        .check_info_text {
          font-size: 16px;
        }
        .el-button {
          margin-top: 20px;
        }
      }
      .check_img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 335px;
        height: 209px;
      }
    }
  }
  .el-steps {
    padding-top: 25px;
  }
  /deep/ .el-step__icon.is-text {
    border: nonde;
  }
  /deep/.el-step__icon.is-text {
    width: 35px;
    height: 35px;
    border: none;
  }
  /deep/ .el-step.is-horizontal .el-step__line {
    top: 17px;
  }
  .step01 {
    width: 35px;
    height: 35px;
    background-size: 100% 100%;
    background-image: url('~@/assets/img//bench/finished@2x.png');
  }
  .step02 {
    width: 35px;
    height: 35px;
    background-size: 100% 100%;
    background-image: url('~@/assets/img//bench/unstart@2x.png');
  }
}
.confirm_target {
  padding: 20px;
  text-align: center;
  .target_content {
    margin-left: 10%;
    width: 90%;
    height: 200px;
    border: 2px solid #eee;
  }
  .target_btn {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;
    .el-button {
      background-color: #ff6a00;
      color: #fff;
    }
  }
}
.el-row {
  padding: 0 20px;
  background-color: #fff;
  padding-top: 10px;
  padding-bottom: 15px;
}
.el-col-3 {
  margin-top: 20px;
  width: 14%;
}
.cardItem {
  cursor: pointer;
  width: 100px;
  text-align: center;
  // height: 145px;
  // margin: 0 auto;
  // padding: 0 20px;
  // padding: 10px;
  // border-radius: 10px;
  // border: 1px solid #ddd;
  box-sizing: border-box;
  -ms-flex-direction: column;
  flex-direction: column;
  border: 1px solid #fff;
}
.cardItem:hover {
  box-shadow: 0 3px 6px rgba(255, 84, 0, 0.15);
  border: 1px solid #ffd581;
  opacity: 1;
}
.cardItem img {
  // margin-left: 20px;
  // margin-top: 10px;
  width: 80px;
  height: 80px;
}
.cardItem_text {
  // margin-top: 10px;
  font-size: 16px;
  text-align: center;
  color: #333;
  // margin-bottom: 20px;
  padding-bottom: 15px;
}
.footer {
  position: absolute;
  height: 60px;
  bottom: -150px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/views/bench/Bench.vue